import { makeResource, mapped } from '@codium/codium-vue'
import { http, queryString } from 'utils'

const actions = {
  async getStages({ dispatch, state }, payload) {
    return http.get(`settings/stages?${queryString(payload)}`).then(response => {
      dispatch('setStages', response.data.data)
     })
  },

  async updateStage({ dispatch, state, getters }, { id, payload }) {
    if (payload === undefined) {
      payload = state.stage
    }

    const response = await http.put(`settings/stages/${id}`, payload)

    dispatch('setStage', response.data.data)
    dispatch('replaceStage', state.stage)

    return cloneDeep(state.stage)
  }
}

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('stages', {
  storeModule: {
    actions
  },
  resource () {
    return {
      id: null,
      name: null,
      lead_time: mapped(null),
      last_edited_by: null,
      updated_at: null
    }
  },
})
